import { render, staticRenderFns } from "./DoKoDialogImages.vue?vue&type=template&id=643b93e2&scoped=true&"
import script from "./DoKoDialogImages.vue?vue&type=script&lang=ts&"
export * from "./DoKoDialogImages.vue?vue&type=script&lang=ts&"
import style0 from "./DoKoDialogImages.vue?vue&type=style&index=0&id=643b93e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643b93e2",
  null
  
)

export default component.exports